// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1199.98px) {}

@media (max-width: 991.98px) {

    .left-sidebar {
        position: fixed;
        z-index: 11 !important;
        top: 136px;
        height: 100%;
        left: -250px;
    }

    body.open .left-sidebar {
        left: 0;
        padding: 24px;
        width: 245px;
    }

    .sidebar-overlay {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease;
        z-index: 10;
    }

    body.open .sidebar-overlay {
        opacity: 1;
        visibility: visible;
    }

    .content-area {
        min-width: 100%;
    }

    /* Page Heading */
    .page-heading .welcome-text p {
        font-size: 14px;
    }

    /* Modules */
    .page-modules .module-item .module-title {
        font-size: 16px;
    }

    .page-modules .module-item .module-box {
        padding: 26px;
    }
}

@media (max-width: 767.98px) {

    /* Header */
    .header .logo {
        width: 120px;
        padding-right: 16px;
    }

    .header .logo img {
        max-width: 90px;
    }

    .header .logo small {
        font-size: 10px;
        line-height: normal;
    }

    .header .dropdown-menu.notifications {
        width: 300px;
        overflow-y: auto;
    }

    .header .dropdown-menu.notifications a {
        width: 276px;
    }

    .page-breadcrumbs {
        top: 61px;
    }

    .page-breadcrumbs .back-btn {
        min-width: auto;
        padding-right: 16px;
    }

    .page-name {
        font-size: 16px;
    }

    /* Modules */
    .left-sidebar {
        top: 104px;
    }

    body.open .left-sidebar {
        width: 280px;
    }

    .left-sidebar .nav-sidebar {
        width: 100%;
    }

    .sub-layout .content-wrapper {
        background-color: var(--bs-body-bg);
    }

    .inner-layout .left-bar {
        height: calc(100vh - 104px);
    }

    .sub-layout .body-area {
        border-radius: 0;
        width: 100%;
        height: calc(100vh - 106px);
    }

    .sub-layout .body-area .ai-image-card {
        width: 100%;
    }

    .login-container>.row {
        height: 100vh;
    }

    /* table list and mobile grid view */
    .table-row-grid tr {
        display: flex;
        flex-direction: column;
        margin-bottom: 5px;
        padding: 16px 0;
    }

    .table-row-grid tr td {
        width: 100%;
        text-align: center;
    }

    .event-list tr td img {
        width: 330px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/responsive.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;;IAEI;QACI,eAAe;QACf,sBAAsB;QACtB,UAAU;QACV,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,OAAO;QACP,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,8BAA8B;QAC9B,UAAU;QACV,kBAAkB;QAClB,6BAA6B;QAC7B,WAAW;IACf;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA,iBAAiB;IACjB;QACI,eAAe;IACnB;;IAEA,YAAY;IACZ;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;;IAEI,WAAW;IACX;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA,YAAY;IACZ;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA,oCAAoC;IACpC;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":["@media (max-width: 1199.98px) {}\n\n@media (max-width: 991.98px) {\n\n    .left-sidebar {\n        position: fixed;\n        z-index: 11 !important;\n        top: 136px;\n        height: 100%;\n        left: -250px;\n    }\n\n    body.open .left-sidebar {\n        left: 0;\n        padding: 24px;\n        width: 245px;\n    }\n\n    .sidebar-overlay {\n        display: block;\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.4);\n        opacity: 0;\n        visibility: hidden;\n        transition: opacity 0.3s ease;\n        z-index: 10;\n    }\n\n    body.open .sidebar-overlay {\n        opacity: 1;\n        visibility: visible;\n    }\n\n    .content-area {\n        min-width: 100%;\n    }\n\n    /* Page Heading */\n    .page-heading .welcome-text p {\n        font-size: 14px;\n    }\n\n    /* Modules */\n    .page-modules .module-item .module-title {\n        font-size: 16px;\n    }\n\n    .page-modules .module-item .module-box {\n        padding: 26px;\n    }\n}\n\n@media (max-width: 767.98px) {\n\n    /* Header */\n    .header .logo {\n        width: 120px;\n        padding-right: 16px;\n    }\n\n    .header .logo img {\n        max-width: 90px;\n    }\n\n    .header .logo small {\n        font-size: 10px;\n        line-height: normal;\n    }\n\n    .header .dropdown-menu.notifications {\n        width: 300px;\n        overflow-y: auto;\n    }\n\n    .header .dropdown-menu.notifications a {\n        width: 276px;\n    }\n\n    .page-breadcrumbs {\n        top: 61px;\n    }\n\n    .page-breadcrumbs .back-btn {\n        min-width: auto;\n        padding-right: 16px;\n    }\n\n    .page-name {\n        font-size: 16px;\n    }\n\n    /* Modules */\n    .left-sidebar {\n        top: 104px;\n    }\n\n    body.open .left-sidebar {\n        width: 280px;\n    }\n\n    .left-sidebar .nav-sidebar {\n        width: 100%;\n    }\n\n    .sub-layout .content-wrapper {\n        background-color: var(--bs-body-bg);\n    }\n\n    .inner-layout .left-bar {\n        height: calc(100vh - 104px);\n    }\n\n    .sub-layout .body-area {\n        border-radius: 0;\n        width: 100%;\n        height: calc(100vh - 106px);\n    }\n\n    .sub-layout .body-area .ai-image-card {\n        width: 100%;\n    }\n\n    .login-container>.row {\n        height: 100vh;\n    }\n\n    /* table list and mobile grid view */\n    .table-row-grid tr {\n        display: flex;\n        flex-direction: column;\n        margin-bottom: 5px;\n        padding: 16px 0;\n    }\n\n    .table-row-grid tr td {\n        width: 100%;\n        text-align: center;\n    }\n\n    .event-list tr td img {\n        width: 330px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
